<template>
  <el-dialog
    :title="settleType == 1 ? '线下打款' : '线上打款'"
    :visible="visible"
    @close="cancel"
    width="500px"
    class="settle-dialog"
  >
    <div class="payment-content">
      <!-- 结算信息区域 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-s-shop"></i>
          <span>结算信息</span>
        </div>
        <div class="info-list">
          <div class="info-item highlight">
            <span class="label">结算门店：</span>
            <span class="value highlight-value">{{ detail.store ? detail.store.storeName : "-" }}</span>
          </div>
          <div v-if="settleType == 2" class="info-item highlight">
            <span class="label">收款账户姓名：</span>
            <span class="value highlight-value">{{ detail.store ? detail.store.payeeIdName : "-" }}</span>
          </div>
          <div v-if="settleType == 2" class="info-item highlight">
            <span class="label">收款支付宝账号：</span>
            <span class="value highlight-value">{{ detail.store ? detail.store.payeeAlipayAccount : "-" }}</span>
          </div>
          <div class="info-item amount-item">
            <span class="label">门店结算金额：</span>
            <span class="value amount-value">
              {{ detail.settleAmount || "-" }}<span class="unit">元</span>
            </span>
          </div>
        </div>
      </div>

      <!-- 订单信息区域 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-document"></i>
          <span>订单信息</span>
        </div>
        <div class="info-list">
          <div class="info-item">
            <span class="label">订单号：</span>
            <span class="value">{{ orderNo || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">商品信息：</span>
            <span class="value">{{ detail.goodsTitle || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">商品进货价：</span>
            <span class="value">￥{{ detail.costAmount || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">客户首付款：</span>
            <span class="value">
              ￥{{ detail.prepayAmount || "-" }}
              <el-tag size="mini" :type="detail.prepayPayeeType == 1 ? 'info' : 'success'" style="margin-left: 8px;">
                {{ detail.prepayPayeeType == 1 ? "平台收取" : "门店收取" }}
              </el-tag>
            </span>
          </div>
          <div class="info-item">
            <span class="label">监管服务费：</span>
            <span class="value">
              ￥{{ detail.lockAmount || "-" }}
              <el-tag size="mini" :type="detail.lockPayeeType == 1 ? 'info' : 'success'" style="margin-left: 8px;">
                {{ detail.lockPayeeType == 1 ? "平台收取" : "门店收取" }}
              </el-tag>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="footer">
      <div class="footer-tips" v-if="settleType === 1">
        <i class="el-icon-warning"></i>
        <span>请仔细核对!</span>
      </div>
      <div class="footer-buttons">
        <el-button @click="cancel" size="small" class="cancel-btn">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          v-if="settleType === 1"
          @click="offlinePay"
          class="submit-btn"
          >已完成打款</el-button
        >
        <el-button
          size="small"
          type="primary"
          v-if="settleType === 2"
          @click="onlinePayRetry"
          class="submit-btn"
          >打款重试</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getSettleInfoAPI, offlinePay, alipayRetry } from "./api";
export default {
  props: {
    visible: { type: Boolean, default: false },
    settleType: { type: Number, default: 1 },
    orderNo: { type: String, default: "" },
  },
  data() {
    return {
      detail: {
        costAmount: "",
        depositAmount: "",
        depositPayeeType: 0,
        goodsTitle: "",
        lockAmount: "",
        lockPayeeType: 1,
        prepayAmount: "",
        prepayPayeeType: 1,
        settleAmount: "",
        store: null,
      },
    };
  },
  watch: {
    visible(visible) {
      if (!visible) {
        return;
      }

      this.init();
    },
  },
  methods: {
    cancel() {
      this.$emit("update:visible", false);
    },
    async onlinePayRetry() {
      await alipayRetry({
        orderNo: this.orderNo,
      });

      this.$message.success("重试成功");

      this.$emit("ok");
    },
    async offlinePay() {
      await offlinePay({
        orderNo: this.orderNo,
      });

      this.$message.success("打款成功");

      this.$emit("ok");
    },
    async init() {
      this.detail = await getSettleInfoAPI({
        orderNo: this.orderNo,
        settleType: this.settleType,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .settle-dialog {
  .el-dialog {
    border-radius: 12px;
    overflow: hidden;
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1e25;
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
    
    .el-dialog__body {
      padding: 24px;
      background: #fafbfc;
    }
    
    .el-dialog__footer {
      padding: 16px 24px;
      background: #ffffff;
      border-top: 1px solid #f0f2f5;
    }
  }
}

.payment-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-section {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e4e7ed;
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f2f5;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: linear-gradient(180deg, #409EFF 0%, #66b1ff 100%);
      border-radius: 2px;
    }
    
    i {
      font-size: 18px;
      color: #409EFF;
      margin-left: 8px;
    }
  }
  
  .info-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .info-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-radius: 8px;
    transition: all 0.3s ease;
    line-height: 1.6;
    
    &:hover {
      background: #f5f7fa;
    }
    
    &.highlight {
      background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
      border: 1px solid #fbc4c4;
      
      &:hover {
        background: linear-gradient(135deg, #fde2e2 0%, #fcd5d5 100%);
      }
    }
    
    &.amount-item {
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border: 1px solid rgba(64, 158, 255, 0.2);
      padding: 16px 12px;
      
      &:hover {
        background: linear-gradient(135deg, #e6f2ff 0%, #dcebff 100%);
      }
    }
    
    .label {
      font-weight: 600;
      min-width: 130px;
      color: #606266;
      font-size: 14px;
      flex-shrink: 0;
    }
    
    .value {
      color: #303133;
      font-size: 14px;
      flex: 1;
      word-break: break-all;
      
      &.highlight-value {
        color: #f56c6c;
        font-weight: 600;
      }
      
      &.amount-value {
        color: #409EFF;
        font-size: 24px;
        font-weight: 700;
        display: flex;
        align-items: baseline;
        gap: 4px;
        
        .unit {
          font-size: 14px;
          font-weight: 500;
          color: #909399;
        }
      }
    }
  }
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  
  .footer-tips {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #f56c6c;
    font-size: 13px;
    font-weight: 600;
    padding: 8px 12px;
    background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
    border-radius: 6px;
    border: 1px solid #fbc4c4;
    width: 100%;
    justify-content: center;
    
    i {
      font-size: 16px;
    }
  }
  
  .footer-buttons {
    display: flex;
    gap: 12px;
    width: 100%;
    justify-content: flex-end;
    
    .cancel-btn {
      border-radius: 8px;
      padding: 10px 20px;
      font-weight: 500;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
    
    .submit-btn {
      border-radius: 8px;
      padding: 10px 20px;
      font-weight: 600;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      transition: all 0.3s ease;
      
      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
        transform: translateY(-1px);
      }
      
      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  ::v-deep .settle-dialog {
    .el-dialog {
      width: 90% !important;
      margin: 5vh auto !important;
    }
  }
  
  .info-section {
    padding: 16px;
    
    .info-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      
      .label {
        min-width: auto;
        width: 100%;
        text-align: left;
      }
    }
  }
  
  .footer {
    .footer-buttons {
      flex-direction: column;
      
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>
